import { V } from "@/lib/vocab";
// Client-side twin of backend sms_segments(): GSM-7 (160 / 153) vs Unicode (70 / 67).
export function smsSegments(text, extra = 0) {
  const s = (text || "") + (extra ? "x".repeat(extra) : "");
  if (!s) return 0;
  const uni = /[^\u0000-\u007f]/.test(s);
  const n = s.length;
  if (uni) return n <= 70 ? 1 : Math.ceil(n / 67);
  return n <= 160 ? 1 : Math.ceil(n / 153);
}

// Under an invite / launch composer: how many texts this costs per resident, against the allowance.
export function SegmentMeter({ text, extraChars = 0, testId = "segment-meter" }) {
  if (!text?.trim()) return null;
  const segs = smsSegments(text, extraChars);
  const long = segs > 3;
  return (
    <div data-testid={testId} className={`mt-1.5 flex flex-wrap items-center gap-x-2 text-[11px] ${long ? "text-amber-700" : "text-ink/55"}`}>
      <span><strong data-testid={`${testId}-count`}>{segs}</strong> text segment{segs === 1 ? "" : "s"} per {V.lc("person")}{extraChars ? " (with the required notice)" : ""}</span>
      <span>· counts as {segs} toward the monthly allowance</span>
      {long && <span data-testid={`${testId}-long`} className="font-semibold">· long — aim for 3 or fewer; put details behind the link</span>}
    </div>
  );
}
